import './BvcSlider.vue.css';

import { ref, computed } from '../_snowpack/pkg/vue.js';
const defaultExport = {
    props: {
        'label': String,
        'tooltip': String,
        'value': Number,
        'modelValue': Number,
        'min': [Number, String],
        'max': [Number, String],
        'step': [Number, String],
        'tickStep': [Number, String],
        'unit': String
    },
    emits: [
        'update:modelValue'
    ],
    methods: {
        updateValue(x) {
            this.$emit('update:modelValue', parseFloat(x))
        },
    },
    setup(props) {
        const _val = props.modelValue || props.value || 0;
        const value = ref(_val);
        const asNumber = x => parseInt(x.toString().replace(/\D/g, ''), 10);
        const sliderMin = asNumber(props.min);
        const sliderMax = asNumber(props.max);
        const ticks = {
            [sliderMin]: props.min,
            [sliderMax]: props.max
        };
        const step = parseInt(props.step, 10) || 1;

        if (props.tickStep) {
            for (let i = sliderMin; i < sliderMax; i += +props.tickStep) {
                ticks[i] = i.toString();
            }
        }

        return {
            ...props,
            value,
            step,
            sliderMin,
            sliderMax,
            ticks,
            unit: props.unit === '$' ? props.unit : ''
        }
    }
};

import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "../_snowpack/pkg/vue.js"

const _withScopeId = n => (_pushScopeId("data-v-ba4e37ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bvc-slider-container" }
const _hoisted_2 = { class: "bvc-label" }

export function render(_ctx, _cache) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_tooltip = _resolveComponent("v-tooltip")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_slider = _resolveComponent("v-slider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _createVNode(_component_v_text_field, {
        modelValue: _ctx.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
          _ctx.updateValue
        ],
        "hide-details": "",
        "single-line": "",
        density: "compact",
        max: _ctx.max,
        min: _ctx.min,
        step: _ctx.step,
        variant: "outlined",
        style: {},
        prefix: _ctx.unit
      }, {
        "append-inner": _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "px-2",
            style: {"min-width":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { icon: "mdi-information-outline" }),
              _createVNode(_component_v_tooltip, {
                activator: "parent",
                location: "top"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tooltip), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onUpdate:modelValue", "max", "min", "step", "prefix"])
    ]),
    _createVNode(_component_v_slider, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = $event => ((_ctx.value) = $event)),
        _ctx.updateValue
      ],
      max: _ctx.sliderMax,
      min: _ctx.sliderMin,
      step: _ctx.step,
      "show-ticks": "always",
      ticks: _ctx.ticks,
      tickSize: 0,
      trackSize: 8,
      "hide-details": "",
      class: "align-center m-0"
    }, null, 8, ["modelValue", "max", "min", "step", "ticks", "onUpdate:modelValue"])
  ]))
};

defaultExport.render = render;

defaultExport.__scopeId = "data-v-ba4e37ee";

export default defaultExport;